<template>
  <svg
    :class="['vuesax-linear-path', className]"
    fill="none"
    height="32"
    viewBox="0 0 32 32"
    width="32"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g class="g" clip-path="url(#clip0_1493_429)">
      <path
        class="path"
        d="M26.3867 9.69333L22.3467 5.65333C20.8133 4.12 18.72 4.2 17.6933 5.84L15.44 9.4L22.64 16.6L26.2 14.3467C27.7333 13.3733 27.8267 11.1333 26.3867 9.69333Z"
        stroke="white"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.5"
      />
      <path
        class="path"
        d="M15.44 9.40003L10.2 9.08003C7.28 8.90669 6.25334 9.80003 5.93334 12.5867L4.62667 23.68C4.34667 26.0134 6.04 27.6934 8.36 27.4134L19.4533 26.1067C22.24 25.7734 23.2533 24.76 22.96 21.84L22.6533 16.6"
        stroke="white"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.5"
      />
      <path
        class="path"
        d="M6.14667 25.8933L10.1867 21.84"
        stroke="white"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.5"
      />
    </g>
    <defs class="defs">
      <clipPath class="clip-path" id="clip0_1493_429">
        <rect class="rect" fill="white" height="32" width="32" />
      </clipPath>
    </defs>
  </svg>
</template>

<script>
export default {
  name: "VuesaxLinearPath",
  props: {
    className: {
      type: String,
      default: "",
    },
  },
};
</script>

<style>
</style>